import { generateTestId } from "@client-shared";
import type { Address } from "@shared/types";

const TEST_ID_PREFIX = "OrderShipToFlagsCell";

export const setOrderShipToFlagsCellTestId = (index: number): string => generateTestId(TEST_ID_PREFIX, "container", index);

export const setOrderShipToFlagsFlagTestId = (index: number, countryCode: string): string =>
  generateTestId(TEST_ID_PREFIX, `flag-${countryCode}`, index);

/**
 * Only a genuine ISO alpha-2 code renders a flag — `country` can hold a full
 * name (e.g. "Netherlands"), which would otherwise mislead CountryFlag's
 * unknown-code fallback into rendering the first two letters as if they were
 * a code. Shared by the cell (rendering) and the column accessor (search/CSV
 * export/grouping value) so both agree on what counts as "has a flag".
 */
export const getShipToFlagCountryCode = (address?: Pick<Address, "countryCode" | "country"> | null): string | undefined => {
  const rawCode = address?.countryCode ?? address?.country;
  return rawCode?.length === 2 ? rawCode.toUpperCase() : undefined;
};
